// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__qqLpJ","avatar":"Item_avatar__GQoZt","man":"Item_man__3bJ0H","position":"Item_position__3I6SX"};